import { BoxGeometry, Mesh } from 'three';
import { ShapeState3D } from '../../../../cross-team-shared/annotation/shared/state/shape-state';
import { VisibilityState } from '../../../../team-apis/otterdam/answers/shape-typings';
import { CuboidMaterial } from '../../../materials/cuboid/cuboid-material';
import { CuboidLocationState3D } from '../../../state/cuboid-location-state-3d';
import { PointCloudContentState } from '../../../state/point-cloud-content-state';
import { determineRendererLayers } from '../../../utils/shape-visibility-utils';
import { setRendererLayers } from '../../render-utils';
import {
  ConfigureMeshesConfiguration,
  RenderConfiguration,
} from '../abstract-mesh-helper';
import { stripedTexture } from '../mesh-utils';

export class CuboidBoxMesh extends Mesh<BoxGeometry, CuboidMaterial> {
  constructor() {
    super(new BoxGeometry());
    this.userData = { meshType: 'Cuboid' };
    this.frustumCulled = false;
  }

  setUserData(index: number, isTraining: boolean) {
    this.userData.shapeIndex = index;
    this.userData.isTraining = isTraining;
  }

  dispose() {
    this.geometry.dispose();
  }

  updateRendererLayers(
    state: PointCloudContentState,
    renderConfig: RenderConfiguration,
    cuboidState: ShapeState3D,
  ) {
    const layers = determineRendererLayers(cuboidState, state, renderConfig);
    setRendererLayers(layers, this);
  }

  updateLocation(location: CuboidLocationState3D) {
    this.position.fromArray(location.position);
    this.rotation.fromArray(location.rotation);
    this.scale.fromArray(location.scale);
  }

  updateMaterial(
    { state, materialService }: ConfigureMeshesConfiguration,
    visibility: VisibilityState,
    color: string,
  ) {
    this.material = materialService.get(CuboidMaterial, {
      color,
      transparent: true,
      opacity: state.render.layerSettings.opacity / 100,
      map: visibility === 0.5 ? stripedTexture : null,
    });
  }
}
